import { Paper, type PaperProps } from "@mui/material";
import { ReactNode } from "react";

interface SideDetailPanelProps extends PaperProps {
  children: ReactNode;
}
const MARGIN_WIDTH = 32;

export default function SideDetailPanel({
  children,
  sx,
  ...props
}: SideDetailPanelProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        position: "sticky",
        top: 16,
        p: 2,
        minHeight: "30vh",
        maxHeight: `calc(100vh - ${MARGIN_WIDTH}px)`,
        overflow: "auto",
        scrollbarGutter: "stable",
        borderRadius: "5px 0 0 5px",
        justifyContent: "center",
        alignItems: "center",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
}
